export default __webpack_public_path__ + "static/media/SLM.11c1fbd0.jpg";